import * as types from '../actions/camerasRecordingsAction';

const initialState = {
  restaurantUuid: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  intervalEnd: null,
  timezone: null,
  limit: '20',
  page: 0,
  totalResults: 0,
  sortBy: 'createdDate',
  orderDirection: 'DESC',
  search: '',
  loading: false,
  scrollLoading: false,
  readyLoading: false,
  cursorDirection: 'FIRST',
  cursor: null,
  existNext: false,
  existPrevious: false,
  recordings: [],
  readyRecordings: [],
  camerasPreviousRequest: null,
};

const camerasRecordingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_CAMERAS_RECORDINGS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_CAMERAS_RECORDINGS_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.GET_CAMERAS_RECORDINGS: {
      return {
        ...state,
        readyLoading: true,
      };
    }

    case types.GET_CAMERAS_RECORDINGS_SUCCESS: {
      const preparedRecordings = action.payload.content.map((item) => ({
        ...item,
        metadata: JSON.parse(item.metadata),
        preview: { image: null, loading: true, error: false },
        isDownloading: false,
        progress: 0,
        controller: null,
      }));
      return {
        ...state,
        readyLoading: false,
        cursor: action.payload.cursor,
        cursorDirection: action.payload.cursorDirection,
        existNext: action.payload.existsNextPage,
        existPrevious: action.payload.existsPreviousPage,
        readyRecordings:
          action.params.cursorDirection === 'NEXT'
            ? [...state.readyRecordings, ...preparedRecordings]
            : preparedRecordings,
      };
    }

    case types.GET_CAMERAS_RECORDINGS_ERROR: {
      return {
        ...state,
        readyLoading: false,
      };
    }

    case types.SET_CAMERA_RECORDING_PREVIEW: {
      return {
        ...state,
        readyRecordings: state.readyRecordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                preview: action.payload.preview,
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_CAMERA_RECORDING: {
      return {
        ...state,
        readyRecordings: state.readyRecordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: true,
                progress: 0,
                controller: action.payload.controller,
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_CAMERA_RECORDING_SUCCESS:
    case types.DOWNLOAD_CAMERA_RECORDING_ERROR: {
      return {
        ...state,
        readyRecordings: state.readyRecordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: false,
                progress: 0,
                controller: null,
              }
            : recording
        ),
      };
    }

    case types.SET_CAMERA_RECORDING_PROGRESS: {
      return {
        ...state,
        readyRecordings: state.readyRecordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                progress: action.payload.progress,
              }
            : recording
        ),
      };
    }

    case types.GET_SCHEDULED_RECORDINGS: {
      return {
        ...state,
        loading: true,
        recordings: [],
      };
    }

    case types.GET_SCHEDULED_RECORDINGS_SUCCESS: {
      return {
        ...state,
        loading: false,
        recordings: action.payload.content,
        totalResults: action.payload.total,
      };
    }

    case types.GET_SCHEDULED_RECORDINGS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }

    case types.UPDATE_SCHEDULED_RECORDING: {
      return {
        ...state,
        recordings: state.recordings.map((recording) =>
          recording.recordingId === action.payload.recording.recordingId
            ? action.payload.recording
            : recording
        ),
      };
    }

    case types.RESET_CAMERAS_RECORDINGS_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default camerasRecordingsReducer;
